import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import Calendar from './Calendar'
import CreateRota from './CreateRota'
import RotasTable from './RotasTable'
import CreateEvent from './CreateEvent'
import CustomEventsTable from './CustomEventsTable'

class Planner extends FirebaseComponent {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <Calendar/>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <h4>Add a rota</h4>
            <RotasTable/>
            <CreateRota/>
          </div>
          <div className="col-sm-6">
            <h4>Add a custom event</h4>
            <CustomEventsTable/>
            <CreateEvent/>
          </div>
        </div>
      </div>
    )
  }
}

export default Planner



// WEBPACK FOOTER //
// ./src/Planner.js